import {
  Box,
  Button,
  Center,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Radio,
  RadioGroup,
  Stack,
  Text
} from '@chakra-ui/react'
import { Chart, registerables } from 'chart.js'
import { useEffect, useState } from 'react'

import { Icon } from '../../../components/Icon'
import { LoadingBlock } from '../../../components/Loading'
import { StarRating } from '../../../components/StarRating'
import { formatApiDate } from '../../../helpers'
import { IAceleraMagentaAnswer as IConexaoMagentaAnswer } from '../../../interfaces/IAceleraMagentaAnswer'
import ConexaoMagentaService from '../../../services/ConexaoMagenta/ConexaoMagentaService'

Chart.register(...registerables)

interface IFormField {
  id: number
  title: string
  type: string
  options: string
  groups: string
}

export default function ConexaoMagentaViewPage({ conexaoMagentaId: id }: { conexaoMagentaId: number }) {
  const conexaoMagentaService = new ConexaoMagentaService()
  const [form, setForm] = useState<IFormField[]>([])
  const [formTitle, setFormTitle] = useState<string>('')
  const [formAnswers, setFormAnswers] = useState<IConexaoMagentaAnswer>({})
  const [step, setStep] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    window.scrollTo(0, 0)
    loadFormPage()
  }, [step])

  useEffect(() => {
    window.scrollTo(0, 0)
    loadFormPage()
  }, [])

  const loadFormPage = async () => {
    setLoading(true)
    conexaoMagentaService
      .getResponses(id, step)
      .then((response) => {
        setFormAnswers({})
        setForm([])

        const answers: IConexaoMagentaAnswer = {}
        response.data.answers.forEach((answer: { question_id: number; answer: string }) => {
          answers[answer.question_id] = answer.answer
        })
        setFormAnswers(answers)

        setFormTitle(response.data.form.name)
        setForm(response.data.questions)
      })
      .finally(() => setLoading(false))
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
  }

  return (
    <>
      <Center>
        <Image src="/img/conexao-magenta.png" alt="Conexão Magenta" w="65%" marginBottom="10" />
      </Center>
      {loading && <LoadingBlock size="page" />}
      {!loading && (
        <>
          <Heading as="h2" mb="4">
            {formTitle}
          </Heading>
          <form onSubmit={handleSubmit}>
            {form.map((field) => {
              return (
                <>
                  <FormControl key={field.id} mb="4">
                    <FormLabel>{field.title}</FormLabel>
                    {field.type === 'textarea' &&
                      formAnswers[field.id].split('\n').map((line, index) => <Text key={index}>{line}</Text>)}
                    {field.type === 'text' &&
                      formAnswers[field.id].split('\n').map((line, index) => <Text key={index}>{line}</Text>)}
                    {field.type === 'date' && formatApiDate(formAnswers[field.id])}
                    {field.type === 'options' && (
                      <RadioGroup value={formAnswers[field.id]}>
                        <Stack direction="column" spacing={3}>
                          {(JSON.parse(field.options) as string[]).map((option, index) => (
                            <Radio value={(index + 1).toString()} key={index} isDisabled>
                              {step !== 2 && step !== 4 && option}
                              {step === 2 && (
                                <>
                                  {JSON.parse(field.groups)[index] == 4 && (
                                    <Text color="green" fontWeight="semibold">
                                      {option}
                                    </Text>
                                  )}
                                  {JSON.parse(field.groups)[index] != 4 &&
                                    ((formAnswers[field.id] == (index + 1).toString() &&
                                      JSON.parse(field.groups)[parseInt(formAnswers[field.id]) - 1] != 4 && (
                                        <Text color="tomato" fontWeight="semibold">
                                          {option}
                                        </Text>
                                      )) ||
                                      option)}
                                </>
                              )}
                            </Radio>
                          ))}
                        </Stack>
                      </RadioGroup>
                    )}
                    {field.type === 'checkbox' && (
                      <CheckboxGroup value={JSON.parse(formAnswers[field.id])}>
                        {(JSON.parse(field.options) as string[]).map((option, index) => (
                          <Checkbox value={(index + 1).toString()} key={index} marginLeft="2">
                            {option}
                          </Checkbox>
                        ))}
                      </CheckboxGroup>
                    )}
                    {field.type === 'stars' && <StarRating value={parseInt(formAnswers[field.id] ?? '0')} />}
                  </FormControl>
                </>
              )
            })}

            <Box display={['none', 'none', 'block']}>
              <Button
                colorScheme="blackAlpha"
                opacity="90%"
                type="button"
                onClick={() => setStep(step - 1)}
                position={'fixed'}
                left={'5rem'}
                bottom={'50%'}
                fontSize={'xxx-large'}
                padding={'30px 5px'}
                textAlign={'center'}
                disabled={step <= 0}
              >
                <Icon name="lni lni-chevron-left" />
              </Button>
              <Button
                colorScheme="blackAlpha"
                opacity="90%"
                type="button"
                onClick={() => setStep(step + 1)}
                position={'fixed'}
                right={'6rem'}
                bottom={'50%'}
                fontSize={'xxx-large'}
                padding={'30px 5px'}
                textAlign={'center'}
                disabled={step >= 1}
              >
                <Icon name="lni lni-chevron-right" />
              </Button>
            </Box>
          </form>
        </>
      )}
    </>
  )
}
